module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/~/crossfilter/index.js
// module id = 50
// module chunks = 0